import React, { useState } from 'react';

export const ErrorList = React.forwardRef((props, ref) => {
  let modifiedErrors = [];

  if (Object.keys(props.formik.errors).length > 0) {
    modifiedErrors = (props.formik.errors.DataGraphs || [])
      .map((dataGraph, dataGraphIndex) => {
        if (dataGraph && dataGraph.PersistentGraphFilters) {
          return dataGraph.PersistentGraphFilters.map((filter, filterIndex) => {
            if (filter) {
              return {
                FieldName: Object.keys(filter)[0],
                Message: Object.values(filter)[0],
                DataGraphIndex: dataGraphIndex,
                PersistentGraphFilterIndex: filterIndex,
              };
            }
            return null; // Keep nulls for accurate indexing
          });
        }
        return [];
      })
      .flat()
      .filter((filter) => filter !== null);
  }

  modifiedErrors = modifiedErrors.reduce(
    (a, e) => {
      const errorKey = `${e.FieldName}_${e.DataGraphIndex}_${e.Message}`;
      if (!a.uniqueKeys.has(errorKey)) {
        a.uniqueKeys.add(errorKey);
        a.filteredErrors.push(e);
      }
      return a;
    },
    { uniqueKeys: new Set(), filteredErrors: [] },
  ).filteredErrors;

  return (
    <>
      {modifiedErrors.length > 0 || props.formik.errors.IsPublic ? (
        <div className="ui error message">
          <div className="header">Some errors need your attention...</div>
          <ul className="list">
            {props.formik.errors.IsPublic ? (
              <li key={'is-public-preset'}>{`${props.formik.errors.IsPublic}`}</li>
            ) : null}
            {modifiedErrors.map((e, idx) => {
              const dgi = e.DataGraphIndex;
              const pgfi = e.PersistentGraphFilterIndex;

              const DataGraphName =
                props.data.DataGraphs[dgi]?.Name || `Graph #${props.data.DataGraphs[dgi]?.DisplayOrder}`;
              const StationName =
                props.data.DataGraphs[dgi]?.PersistentGraphFilters[pgfi]?.weatherStationInfo?.DropdownText ||
                'Station: Any';

              return (
                <li key={`${idx}`}>{`'${e.Message}' in '${StationName}' under Data Graph named '${DataGraphName}'`}</li>
              );
            })}
          </ul>
        </div>
      ) : null}
    </>
  );
});

ErrorList.displayName = 'ErrorList';
